import React from 'react'
import styled from 'styled-components'
import {motion, useReducedMotion} from 'framer-motion'
import Me from '../assets/Images/profile-img.png'


const Box = styled(motion.div)`

position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
cursor: crosshair;

width: 65vw;
height:55vh;
display: flex;


background: linear-gradient(
    to right,
    ${props => props.theme.body} 50%,
    ${props => props.theme.text} 50%) bottom,
    linear-gradient(
    to right,
    ${props => props.theme.body} 50%,
    ${props => props.theme.text} 50%) top;
    background-repeat: no-repeat;
    background-size: 100% 2px;
    border-left: 2px solid ${props => props.theme.body};
    border-right: 2px solid ${props => props.theme.text};
    z-index:1;

    @media (max-width: 768px) {
     flex-direction: column;
    width: 74vw;
    height: 70vh;

    /* change background to vertical split */
    background: linear-gradient(
        to bottom,
        ${props => props.theme.body} 50%,
        ${props => props.theme.text} 50%
      ) right,
      linear-gradient(
        to bottom,
        ${props => props.theme.body} 50%,
        ${props => props.theme.text} 50%
      ) left;
    background-repeat: no-repeat;
    background-size: 2px 100%;

    /* switch borders */
    border-top: 2px solid ${props => props.theme.body};
    border-bottom: 2px solid ${props => props.theme.text};
    border-left: none;
    border-right: none;
  }
`
const SubBox = styled.div`
width: 50%;
position: relative;
display: flex;
.pic{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0%);
    width: 100%;
    height: auto;
}

 @media (max-width: 768px) {
    width: 100%;
    height: 50%;
    .pic {
      width: auto;
      max-height: 100%;
    }
  }

`

const Text = styled.div`
font-size: clamp(1rem, calc(0.85rem + 1.1vw), 2.2rem);
color: ${props => props.theme.body};
padding: 2rem;
cursor: default;

display: flex;
flex-direction: column;
justify-content: center;
gap: 0.55rem;

h1{
    margin-bottom: 0.2rem;
}

h3{
    font-size: 0.75em;
}

p{
    color: ${props => `rgba(${props.theme.bodyRgba},0.6)` };
    font-size: clamp(0.88rem, calc(0.62rem + 0.6vw), 1.15rem);
    font-weight:300;
    line-height: 1.55;
}
`

const Intro = () => {
    const shouldReduceMotion = useReducedMotion();
    return (
        <Box
        initial={shouldReduceMotion ? false : {height:0}}
        animate={{height: '55vh'}}
        transition={shouldReduceMotion ? { duration: 0 } : { type: 'spring', duration:2, delay:1 }}
        >
            <SubBox>
                <Text>
                    <h1>Hi,</h1>
                    <h3>I'm Sitheswar.</h3>
                    <p>
                      A full-stack developer focused on building clean, reliable products with
                      strong attention to usability and performance.
                    </p>
                </Text>
            </SubBox>
            <SubBox>
                <motion.div
                initial={shouldReduceMotion ? false : {opacity:0}}
                animate={{opacity: 1}}
                transition={shouldReduceMotion ? { duration: 0 } : { duration:1, delay:2 }}
                >
                    <img className="pic" src={Me} alt="Profile Pic" />
                </motion.div>
            </SubBox>
        </Box>
    )
}

export default Intro


